export default __webpack_public_path__ + "assets/images/others/2b0139153615bacb457ae882bb81df47.png";